import { render, staticRenderFns } from "./_record_tag_manager.vue?vue&type=template&id=0aa4c416&"
import script from "./_record_tag_manager.vue?vue&type=script&lang=js&"
export * from "./_record_tag_manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports